/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import ApiError from '../model/ApiError';
import JobTag from '../model/JobTag';
import JobTagLink from '../model/JobTagLink';
import JobTagUpdateRequest from '../model/JobTagUpdateRequest';
import SaveJobTagRequest from '../model/SaveJobTagRequest';
import SuccessResponse from '../model/SuccessResponse';

/**
* JobTag service.
* @module api/JobTagApi
* @version V1
*/
export default class JobTagApi {

    /**
    * Constructs a new JobTagApi. 
    * @alias module:api/JobTagApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the createJobTag operation.
     * @callback module:api/JobTagApi~createJobTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/JobTag} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SaveJobTagRequest} [saveJobTagRequest] 
     * @param {module:api/JobTagApi~createJobTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/JobTag}
     */
    createJobTag(opts, callback) {
      opts = opts || {};
      let postBody = opts['saveJobTagRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AccessToken'];
      let contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = JobTag;
      return this.apiClient.callApi(
        '/job-tags', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteJobTag operation.
     * @callback module:api/JobTagApi~deleteJobTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SuccessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Number} jobTagId 
     * @param {module:api/JobTagApi~deleteJobTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SuccessResponse}
     */
    deleteJobTag(jobTagId, callback) {
      let postBody = null;
      // verify the required parameter 'jobTagId' is set
      if (jobTagId === undefined || jobTagId === null) {
        throw new Error("Missing the required parameter 'jobTagId' when calling deleteJobTag");
      }

      let pathParams = {
        'jobTagId': jobTagId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AccessToken'];
      let contentTypes = [];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = SuccessResponse;
      return this.apiClient.callApi(
        '/job-tags/{jobTagId}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getAllJobTags operation.
     * @callback module:api/JobTagApi~getAllJobTagsCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/JobTag>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {module:api/JobTagApi~getAllJobTagsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/JobTag>}
     */
    getAllJobTags(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AccessToken'];
      let contentTypes = [];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = [JobTag];
      return this.apiClient.callApi(
        '/job-tags', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getJobTagLinksForJobId operation.
     * @callback module:api/JobTagApi~getJobTagLinksForJobIdCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/JobTagLink>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Number} jobId 
     * @param {module:api/JobTagApi~getJobTagLinksForJobIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/JobTagLink>}
     */
    getJobTagLinksForJobId(jobId, callback) {
      let postBody = null;
      // verify the required parameter 'jobId' is set
      if (jobId === undefined || jobId === null) {
        throw new Error("Missing the required parameter 'jobId' when calling getJobTagLinksForJobId");
      }

      let pathParams = {
        'jobId': jobId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AccessToken'];
      let contentTypes = [];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = [JobTagLink];
      return this.apiClient.callApi(
        '/job-tags/job/{jobId}/tagLinks', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateJobTag operation.
     * @callback module:api/JobTagApi~updateJobTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/JobTag} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/JobTagUpdateRequest} [jobTagUpdateRequest] 
     * @param {module:api/JobTagApi~updateJobTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/JobTag}
     */
    updateJobTag(opts, callback) {
      opts = opts || {};
      let postBody = opts['jobTagUpdateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AccessToken'];
      let contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = JobTag;
      return this.apiClient.callApi(
        '/job-tags', 'PATCH',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
